import React from 'react';
import Navbar2 from '../navbar/Navbar2';

// Remove all mobile logic and simply render Navbar2 for mobile view
const Navbar = () => {
  return (
    <Navbar2 />
  );
};

export default Navbar;